// Here we define the Type of the Space we want to use
// Which will restrict the developer to use only Defined Value
export enum SpaceType {
  Tiny = 2,
  ExtraSmall = 4,
  Small = 6,
  Basic = 8,
  Extra = 12,
  Double = 16,
  LargeDouble = 20,
  Big = 24,
  large = 32,
  ExtraLarge = 40,
  Size_48 = 48,
  Size_60 = 60,
  Size_80 = 80,
  Size_100 = 100,
}
